export interface MerchantRestrictionMetaForm {
  type: string;
  displayName: string;
  description: string;
}

export interface MerchantRestrictionMetaOption {
  type: string;
  display_name: string;
  description: string;
}

export function transformMerchantRestrictionsMetaPayload(
  merchantRestrictions: Partial<MerchantRestrictionMetaOption>[]
): MerchantRestrictionMetaForm[] {
  return merchantRestrictions.map(({ type, display_name, description }) => ({
    type,
    displayName: display_name || type,
    description: description || '',
  }));
}
